// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__327Gn","notes":"Notes_notes__3Nf_F"};